import React from 'react';
import { usePurchaseRequestByIdQuery } from 'api';
import { useParams } from 'react-router-dom';
import { CommunicationHub } from 'components';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';

export const PurchaseRequestCommunicationHub = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const { id } = useParams() as { id: string };
  const { data: { purchaseRequest = {} } = {} } = usePurchaseRequestByIdQuery({ id }, { skip: !id });

  return (
    <HasAccess role={PERMISSIONS.notes.note.read}>
      <CommunicationHub
        entity={'PURCHASE_REQUEST'}
        hasAccessToWrite={hasAccess(PERMISSIONS.notes.note.write)}
        hasAccessToOtherNoteWrite={hasAccess(PERMISSIONS.notes.other_note.write)}
        hasAccessToOtherNoteDelete={hasAccess(PERMISSIONS.notes.other_note.delete)}
        isFinalStatus={purchaseRequest.isFinalStatus}
        isTabsVisible={true}
      />
    </HasAccess>
  );
});
